<template>
  <div class="panel wraper panel-gray">
    <div class="panel-header">
      <div class="panel-title">
        <unit-path v-once :id="iniDivision.parent_id" :lbl="lbl"></unit-path>
      </div>
    </div>
    <div class="panel-body" id="formbody">
      <q-field
        :error="$v.tempDivision.abbr.$error"
        :error-label="$v.tempDivision.abbr | errorLabel"
      >
        <q-input v-model.trim="tempDivision.abbr" :autofocus="true" float-label="Назв.сокр-ное" />
      </q-field>
      <q-field>
        <q-input v-model.trim="tempDivision.fullName" float-label="Название" />
      </q-field>
      <q-field>
        <q-input v-model.trim="tempDivision.address" float-label="Адрес" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="telString" float-label="Контакты" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="tempDivision.comment" float-label="Заметки" />
      </q-field>
    </div>
    <save-btn :notChanged="notChanged" :goView="goView" :doSave="doSave" />
  </div>
</template>


<script type="text/babel">
import _ from 'lodash';
import 'quasar-extras/animate/bounceInDown.css';
import 'quasar-extras/animate/bounceOutUp.css';
import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import UnitPath from './unit-path.vue';
import SaveBtn from './save-btn.vue';

export default {
  name: 'divisionedit',
  components: {
    UnitPath,
    SaveBtn,
  },
  data() {
    const iniDivision = {
      abbr: '',
      address: '',
      comment: '',
      fullName: '',
      telephones: [],
    };
    if (this.$route.name === 'unitNew') { // new division
      iniDivision.parent_id = this.$route.params.parent_id;
    } else {
      Object.assign(iniDivision, this.$store.state.units[this.$route.params.id]);
    }
    return {
      iniDivision,
      tempDivision: Object.assign({}, iniDivision),
    };
  },
  validations: {
    tempDivision: {
      abbr: {
        required: withParams({ message: 'Введите сокращенное название' }, required),
      },
    },
  },
  mounted() {
    this.$watch('lbl', (a) => {
      document.title = a;
    }, {
      immediate: true,
    });
  },
  computed: {
    lbl() {
      if (this.addNew) {
        return '*Новое подразделение*';
      }
      return this.iniDivision.abbr;
    },
    notChanged() {
      return _.isEqual(this.iniDivision, this.tempDivision);
    },
    telString: {
      get() {
        return this.tempDivision.telephones.join('\n');
      },
      set(newValue) {
        this.tempDivision.telephones = newValue.split('\n').map(t => t.trim());
      },
    },
    hid() {
      return this.iniDivision.parent_id;
    },
    id() {
      return this.$route.params.id;
    },
    addNew() {
      return (this.$route.name === 'unitNew');
    },
  },
  methods: {
    doSave() {
      this.$v.tempDivision.$touch();
      if (this.$v.tempDivision.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.addNew) {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        this.tempDivision._id = `div:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
      }
      // this turn off warning
      Object.assign(this.iniDivision, this.tempDivision);
      this.$store.dispatch('saveUnit', this.tempDivision)
        .then(() => {
          this.$router.jumpBack();
        })
        .catch(() => {
          this.$store.commit('pushError', {
            error: 'Ошибка!',
            message: 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      // this turn off warning -- removed
      // Object.assign(this.iniDivision, this.tempDivision);
      this.$router.jumpBack();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/division-edit.vue